<template>
    <div v-loading="isloading">
        <Plotchart :chartData="chartdata" :chartType="1"/>
        <el-form label-width="160px" label-position="right" :inline="true" size="mini" style="margin-top:20px;">
            <el-form-item label="请选择设备进行查看：" style="margin-bottom:5px;">
                <el-select v-model="eqvalue" placeholder="请选择">
                    <el-option v-for="item in eqoptions"
                               :key="item.Id"
                               :label="item.Code"
                               :value="item.Id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="请选择时间范围：" style="margin-bottom:5px;">
                <el-date-picker v-model="dateRangeValue"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import { GetLineChart, getListPage } from '@/api/utils';
    import Plotchart from "@/components/Plotchart";

    export default {
        name: 'QueryPloatchart',
        components: {
            Plotchart
        },
        props: {
            tableName: {
                type: String
            }
        },
        data() {
            return {
                isloading: true,
                chartdata: {
                    pdata: [],
                    size: { width: 500, height: 400 },
                    title: '',
                    chartid: ''
                },
                eqlist: [],
                eqoptions: [],
                eqvalue: '',
                dateRangeValue: ['', '']
            }
        },
        async created() {
            await this.getequipmentoptions();
            await this.getlinedata(this.eqvalue, '0001-01-01 00:00:00', '0001-01-01 00:00:00');
            this.isloading = false;
        },
        methods: {
            async getequipmentoptions() {
                let res = await getListPage("Equipment", {});
                if (res.Data) {
                    this.eqlist = res.Data.list;
                    res.Data.list.forEach(item => {
                        this.eqoptions.push({ Id: item.Id, Code: item.Code });
                    });
                    this.eqvalue = this.eqoptions[0].Id;
                }
            },
            getchartTitle(eqid) {
                let eqitem = this.eqlist.find(item => item.Id == eqid);
                if (eqitem != undefined)
                    return '[' + eqitem.Code + '] ' + eqitem.Address;
                else return "";
            },
            async getlinedata(equipmentid, starttime, endtime) {
                var params = {
                    equipmentId: equipmentid,
                    startTime: starttime,
                    endTime: endtime
                };
                let res = await GetLineChart(this.tableName, params).catch(() => { });
                if (res.Data && res.Data != undefined) {
                    this.chartdata.title = this.getchartTitle(equipmentid);
                    this.chartdata.chartid = this.tableName;
                    this.chartdata.pdata = [];
                    this.chartdata.pdata.push(res.Data.createtime);
                    this.chartdata.pdata.push(res.Data.height);
                    var filtercol = {
                        filters: [{
                            data: res.Data.id
                        }],
                        columnid: 8,
                        columnname: 'Id',
                        tablename: 'Observation'
                    };
                    this.dtFilterCols = [];
                    this.dtFilterCols.push(filtercol);
                    //this.resize();
                }
            },
            onSubmit() {
                var starttime = this.dateRangeValue[0] == '' ? '0001-01-01 00:00:00' : this.dateRangeValue[0];
                var endtime = this.dateRangeValue[1] == '' ? '0001-01-01 00:00:00' : this.dateRangeValue[1];
                this.getlinedata(this.eqvalue, starttime, endtime);
            }
        },
        watch: {
            eqvalue: {
                handler(newVal) {
                    if (newVal) {
                        this.getlinedata(newVal, '0001-01-01 00:00:00', '0001-01-01 00:00:00');
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>